import { subscribe } from '@/utils'

import { Params, Response } from '.'

const submit = async (params: Params): Promise<Response> => {
	try {
		const body = {
			...params
		}
		const res = await subscribe.put<Response>(
			`account/address/${params.id}`,
			body
		)
		return res.data
	} catch (e) {
		throw e
	}
}

export const service = {
	submit
}
